import type { RoomType } from "building-types/rooms/roomTypesEnum";
import type { ElectricalSpaceClassifier, SpaceClassifierTables } from "./electricalSpaceTypes";
import { electricalSpaceClassifiers } from "./electricalSpaceTypes";

export function optimizeSpaceClassifierTables(): SpaceClassifierTables {
  const primaryClassifier: {
    [key in RoomType]?: ElectricalSpaceClassifier;
  } = {};
  const secondaryClassifier: {
    [key in RoomType]?: ElectricalSpaceClassifier;
  } = {};

  for (const elecRoomClassifierId in electricalSpaceClassifiers) {
    const elecRoomClassifier = electricalSpaceClassifiers[elecRoomClassifierId];
    const { is, isInGroupOf } = elecRoomClassifier;
    const roomType = elecRoomClassifierId as RoomType;
    isInGroupOf === undefined
      ? (primaryClassifier[roomType] = { is, isInGroupOf })
      : (secondaryClassifier[roomType] = { is, isInGroupOf });
  }

  return { primaryClassifier, secondaryClassifier };
}
